'use client';

import { useAppConfigStore } from '@northladder/services';

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

/**
 * -----------------------------------------------------------------------------
 * It renders a toggle button for sidebar header.
 */
export function SidebarToggleButton() {
  const { isSidebarExpanded, setIsSidebarExpanded } = useAppConfigStore();

  const handleSidebarToggle = () => {
    setIsSidebarExpanded(!isSidebarExpanded);
  };

  return (
    <div className="h-0 text-end">
      <div
        className="
          mt-6 inline-block translate-x-2/4 rtl:-translate-x-2/4
        "
      >
        <button
          className="
            flex h-6 w-6 items-center justify-center rounded-lg border
            bg-gray-50 fill-gray-500 transition-all
            duration-700 ease-in-out hover:bg-green-800/20 hover:fill-white
          "
          onClick={handleSidebarToggle}
          type="button"
        >
          {!isSidebarExpanded ? (
            <ChevronRightIcon className="h-3 rtl:rotate-180" />
          ) : (
            <ChevronLeftIcon className="h-3 rtl:rotate-180" />
          )}
        </button>
      </div>
    </div>
  );
}
